"use strict";
/*
 * Created on 01 09 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * Represents single item of {@link EntityAttributeByEntity aggregation}.
 *
 * @author JMe
 */


var EntityAttributeByEntityData =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(EntityAttributeByEntityData, _DomainObject_1$Domai);

  /**
   * @param clazzId identification of a class (not internal id) to enable class name modification and so on
   * @param clazzName class class name (e.g. 'color' class)
   * @param attributeId identification of an attribute (not internal id) to enable attribute name modification and so on.
   * @param attributeName attribute value (e.g. 'blue', 'green' for 'color' class)
   * @param validFrom start of validity of attribute on an entity
   * @param validTo end of validity of attribute on an entity
   */
  function EntityAttributeByEntityData(clazzId, clazzName, attributeId, attributeName, validFrom, validTo) {
    var _this;

    _classCallCheck(this, EntityAttributeByEntityData);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EntityAttributeByEntityData).call(this));
    _this.clazzId = clazzId;
    _this.clazzName = clazzName;
    _this.attributeId = attributeId;
    _this.attributeName = attributeName;
    _this.validFrom = validFrom;
    _this.validTo = validTo;
    return _this;
  }
  /**
   * Converter from data-dictionary representation
   */


  _createClass(EntityAttributeByEntityData, null, [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new EntityAttributeByEntityData(mat.clazzId, mat.clazzName, mat.attributeId, mat.attributeName, mat.validFrom, mat.validTo);
    }
  }]);

  return EntityAttributeByEntityData;
}(DomainObject_1.DomainObject);

exports.EntityAttributeByEntityData = EntityAttributeByEntityData;

EntityAttributeByEntityData.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(EntityAttributeByEntityData.name);
  return {
    clazzId: builder.id('clazzId'),
    clazzName: builder.str('clazzName'),
    attributeId: builder.id('attributeId'),
    attributeName: builder.str('attributeName'),
    validFrom: builder.date('validFrom', DateParser_1.DateParser.ISO_PATTERN),
    validTo: builder.date('validTo', DateParser_1.DateParser.ISO_PATTERN)
  };
}();